module.exports = __webpack_public_path__ + "e982ce1a46db65259241bb5b37266864.svg";